import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addTrackDetailed } from "../api";
import { AddTrackDTO } from "../dtos";
import { Track, TrackDocument } from "../types";

export function useAddTrackDetailed() {
  const queryClient = useQueryClient();

  const mutationAddTrackDetailed = useMutation<
    Track,
    { response?: { data?: { message?: string } } },
    { data: AddTrackDTO; files?: TrackDocument[] }
  >({
    mutationFn: async ({
      data,
      files,
    }: {
      data: AddTrackDTO;
      files?: TrackDocument[];
    }) => {
      const formData = new FormData();
      formData.append(
        "track",
        JSON.stringify({
          ...data,
          property: {
            ...data.property,
            propertyPrice:
              Object.keys(data.property.propertyPrice ?? {}).length > 0
                ? data.property.propertyPrice
                : undefined,
          },
        })
      );
      if (files && files.length > 0) {
        for (const file of files) {
          formData.append(file.documentType, file.file);
        }
      }
      const response = await addTrackDetailed(formData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tracks"] });
    },
  });

  return mutationAddTrackDetailed;
}
